// src/Pages/Common/NotAuthorized.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';

const NotAuthorized = () => {
  return (
    <Box sx={{ p: 4, textAlign: 'center' }}>
      <Typography variant="h4" color="error" gutterBottom>
        403 - Not Authorized
      </Typography>
      <Typography variant="body1">
        You do not have permission to access this page.
      </Typography>
    </Box>
  );
};

export default NotAuthorized;
